<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="品牌列表" style="height:auto" >
      <el-form :inline="true" :model="brandForm" class="demo-form-inline">
        <el-form-item label="中文名称">
          <el-input size="mini" v-model.trim="brandForm.cnName" placeholder="中文名称"></el-input>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input size="mini" v-model.trim="brandForm.enName" placeholder="英文名称"></el-input>
        </el-form-item>
        <el-form-item label="英文简称">
          <el-input size="mini" v-model.trim="brandForm.abbreviation" placeholder="英文简称"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        border>
        <el-table-column
          fixed
          prop="id"
          label="ID编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="cnName"
          label="中文名称"
          show-overflow-tooltip
          width="200">
        </el-table-column>
        <el-table-column
          prop="enName"
          label="英文名称"
          show-overflow-tooltip
          width="240">
        </el-table-column>
        <el-table-column
          prop="abbreviation"
          show-overflow-tooltip
          label="简称"
          width="240">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="supplierLink"
          label="网址">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="160">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      brandForm: {
        cnName: '',
        enName: '',
        abbreviation: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  methods: {
    handleEdit(row) {
      this.$router.push({name:'brandEditor',params:row})
    },
    getBrandData: function() {
      this.optionItem = this.common.extend(this.brandForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/brand/list',
        this.optionItem, res => 
        {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getBrandData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getBrandData()
    }
  },
  mounted: function() {
    this.getBrandData();
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-input--suffix .el-input__inner {
  padding-right: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/brand/brandList.vue